module.exports = __webpack_public_path__ + "static/img/parent-qr.782c1bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/parent-qr.jpg
// module id = 416
// module chunks = 2